import { Box, Icon, IconOwnProps, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import React from 'react'

type Props<Path extends string = string> = {
  icon?: string | ((color: IconOwnProps['color']) => React.ReactNode)
  isActive: boolean
  label: React.ReactNode
  path: Path
  endAdornment?: React.ReactNode

  onClick: (path: Path) => void
}

function NavigatorItem<Path extends string = string>({
  icon,
  isActive,
  label,
  path,
  endAdornment,
  onClick,
}: Props<Path>) {
  const handleClick = React.useCallback(() => onClick(path), [onClick, path])
  const color = isActive ? 'primary' : undefined

  return (
    <ListItem data-testid={`navigator-item-${path.replace(/\//g, '')}`} disablePadding divider>
      <ListItemButton selected={isActive} onClick={handleClick} sx={{ display: 'flex', alignItems: 'center' }}>
        <ListItemIcon>
          {typeof icon === 'string' && <Icon color={color}>{icon}</Icon>}
          {typeof icon === 'function' && icon(color)}
        </ListItemIcon>
        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          <ListItemText
            primary={label}
            sx={{ mr: 1, flex: 1 }}
            slotProps={{
              primary: {
                color,
              },
            }}
          />
          {endAdornment && (
            <Box sx={{ display: 'flex', alignItems: 'center', height: 30, width: 30 }}>{endAdornment}</Box>
          )}
        </Box>
      </ListItemButton>
    </ListItem>
  )
}

export default NavigatorItem

export type { Props as NavigatorItemProps }
